import { put, call, delay, takeEvery } from 'redux-saga/effects';
import { getDepartmentServices, getOTGroupData, getSBGroupData } from '../../VTO/index';
import * as actions from './HomePageAction';

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000; // 1 second delay between retries

export function* getDepartmentServicesData(data) {
    for(let i = 0; i < MAX_RETRIES; i++) {
        try {
            const response = yield call(
                getDepartmentServices,
                data.params,
            )
            if (response?.status === 200) {
                yield put(actions.getDepartmentServicesDataSuccess(true))
                yield put(actions.getDepartmentServicesResponse(response.data))
                return; // Success - exit the function
            } else {
                console.log("ERROR: " + response?.status);
                if (i === MAX_RETRIES - 1) {
                    // Last retry attempt failed
                    yield put(actions.getDepartmentServicesDataSuccess(false))
                } else {
                    yield delay(RETRY_DELAY);
                }
            }
        }
        catch (error) {
            console.log("ERROR: " + error);
            if (i === MAX_RETRIES - 1) {
                // Last retry attempt failed
                yield put(actions.getDepartmentServicesDataSuccess(false))
            } else {
                yield delay(RETRY_DELAY);
            }
        }
    }
}

export function* getOTGroupDataSaga(data) {
    for(let i = 0; i < MAX_RETRIES; i++) {
        try {
            const response = yield call(
                getOTGroupData,
                data.params,
            )
            if (response?.status === 200) {
                yield put(actions.getOTGroupDataSuccess(true))
                yield put(actions.getOTGroupResponse(response.data?.otgroups || []))
                return; // Success - exit the function
            } else {
                console.log("ERROR: " + response?.status);
                if (i === MAX_RETRIES - 1) {
                    // Last retry attempt failed
                    yield put(actions.getOTGroupDataSuccess(false))
                } else {
                    yield delay(RETRY_DELAY);
                }
            }
        }
        catch (error) {
            console.log("ERROR: " + error);
            if (i === MAX_RETRIES - 1) {
                // Last retry attempt failed
                yield put(actions.getOTGroupDataSuccess(false))
            } else {
                yield delay(RETRY_DELAY);
            }
        }
    }
}

export function* getSBGroupDataSaga(data) {
    for(let i = 0; i < MAX_RETRIES; i++) {
        try {
            const response = yield call(
                getSBGroupData,
                data.params,
            )
            if (response?.status === 200) {
                yield put(actions.getSBGroupDataSuccess(true))
                yield put(actions.getSBGroupResponse(response.data?.sbgroups || []))
                return; // Success - exit the function
            } else {
                console.log("ERROR: " + response?.status);
                if (i === MAX_RETRIES - 1) {
                    // Last retry attempt failed
                    yield put(actions.getSBGroupDataSuccess(false))
                } else {
                    yield delay(RETRY_DELAY);
                }
            }
        }
        catch (error) {
            console.log("ERROR: " + error);
            if (i === MAX_RETRIES - 1) {
                // Last retry attempt failed
                yield put(actions.getSBGroupDataSuccess(false))
            } else {
                yield delay(RETRY_DELAY);
            }
        }
    }
}